module.exports = __webpack_public_path__ + "static/media/voucher.ecb49aa3.png";